@use '../@shared/select.mixin' as *;

@layer kol-component {
	@include kol-select;
}
